import { Handle, Position } from "@xyflow/react";
import { VariableType } from "../../../models/interactions/Variable";
import { SwitchCase } from "../../../models/interactions/Switch";
import TypedMatchInput from "../components/TypedMatchInput";
import useSwitchCaseNodePreview from "./useSwitchCaseNodePreview.hook";
import { formatMatchForInput, normalizeMatchFromInput } from "./useSwitchNodePreview.hook";

export default function SwitchCaseNodePreview(props: {
  nodeId: string;
  caseItem: SwitchCase;
  variableType: VariableType | null;
  onChange: (updated: SwitchCase) => void;
  onDelete?: () => void;
  canDelete?: boolean;
}) {
  const { handleStyle } = useSwitchCaseNodePreview(
    props.nodeId,
    props.caseItem.id
  );

  const value = formatMatchForInput(props.caseItem.match);

  return (
    <div className="relative w-full">
      <TypedMatchInput
        label="Case"
        value={value}
        onChange={(nextValue) =>
          props.onChange({
            ...props.caseItem,
            match: normalizeMatchFromInput(nextValue, props.variableType),
          })
        }
        variableType={props.variableType}
        variables={[]}
        allowVariableSelection={false}
        onDelete={props.onDelete}
        canDelete={props.canDelete}
      />
      <Handle
        id={props.caseItem.id}
        type="source"
        position={Position.Right}
        className="switch-case-handle"
        style={handleStyle}
      />
    </div>
  );
}
